// frontend/src/contexts/ChatContext.js

import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from './AuthContext';

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
    const { i18n } = useTranslation();
    const { isAuthenticated } = useContext(AuthContext);

    // This state is only for the chatbot's independent language choice
    const [chatbotLanguage, setChatbotLanguage] = useState(i18n.language);
    
    // START WITH AN EMPTY ARRAY. This is the core change.
    const [chatMessages, setChatMessages] = useState([]);

    // Keep the language sync effect
    useEffect(() => {
        if (i18n.language !== chatbotLanguage) {
            setChatbotLanguage(i18n.language);
            setChatMessages([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);

    // When the user logs out, clear the chat history.
    useEffect(() => {
        if (!isAuthenticated) {
            setChatMessages([]);
        }
    }, [isAuthenticated]);

    const value = { 
        chatMessages, 
        setChatMessages,
        chatbotLanguage,
        setChatbotLanguage
    };

    return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export { ChatContext, ChatProvider };